function Header() {
    return(
        <img src="./images/ProfilePic.png" alt="Profile Pic" />
    )
}

export default Header